module.exports = __webpack_public_path__ + "img/4.ef58de75.jpg";